import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BreadcrumbService } from '../../_services/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule],
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {
  public display = false;
  public header = '';
  public description = '';
  public levels: Array<any> = [];

  constructor(private breadServ: BreadcrumbService,
    public translate: TranslateService,
  ) {
    let storelang = localStorage.getItem("lang") || 'pt';
    this.translate.use(storelang);
    // getting the data from the services
    this.breadServ.getCurrent().subscribe((data: any) => {
      data = this.translateItems(data);
      // console.log("setting breadcrumb...")
      this.display = data.display;
      this.header = data.header;
      this.description = data.description;
      this.levels = data.levels;
    });
  }


  translateItems(items: any) {
    if(items.header != "") {
      const translatedName = this.translate.instant(items.header.toLowerCase());
      if (items.header.toLowerCase() === translatedName) {
        console.log(`Não há tradução disponível para: ${items.header}`);
      } else {
        items.header = translatedName;
      }
    }

    if(items.description != "") {
      const translatedName = this.translate.instant(items.description.toLowerCase());
      if (items.description.toLowerCase() === translatedName) {
        console.log(`Não há tradução disponível para: ${items.description}`);
      } else {
        items.description = translatedName;
      }
    }
    return items;
  }
}
